@import "./helpers/scss-helper";

/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$content-aggregator-desktop-large-radius: 0 !default;
$content-aggregator-desktop-radius: 0 !default;
$content-aggregator-tablet-radius: 0 !default;
$content-aggregator-mobile-radius: 0 !default;

:host {
  display: block;
  font-family: $font-family-base;
  text-align: left;
}

.#{$prefix}content-aggregator-item__list {
  text-decoration: none;
  outline-style: none;

  &:hover {
    outline-style: none;

    .#{$prefix}content-aggregator-item__list--wrapper {
      @if (variable-exists(content-aggregator-drop-shadow-on-hover)) {
        box-shadow: $content-aggregator-drop-shadow-on-hover;
      }
    }

  }

  &--wrapper {
    cursor: pointer;
    display: grid;
    font-family: $font-family-base;
    grid-template-columns: repeat(12, [col-start] 1fr);
    overflow: hidden;
    background-color: v(backgroundColor);
    border-radius: $content-aggregator-desktop-large-radius;

    @include for-size(desktop) {
      border-radius: $content-aggregator-desktop-radius;
    }

    @include for-size(tablet) {
      border-radius: $content-aggregator-tablet-radius;
    }

    @include for-size(phone) {
      border-radius: $content-aggregator-mobile-radius;
    }

    @include for-size(phone) {
      grid-template-columns: 100%;
      grid-template-areas: "date" "content" "button";
      position: relative;
    }
  }

  &--content {
    font-family: $font-family-base;
    grid-column: 2 col-start / -2;
    padding: 24px 28px 32px 48px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: v(contentColor);

    &.#{$prefix}size-h5 {
      padding: 27px 28px 27px 48px;

      @include for-size(desktop) {
        padding: 25px 32px;
      }
      @include for-size(tablet) {
        padding: 24px 24px 24px 32px;
      }

      .#{$prefix}content-aggregator-item__list--headline {
        margin-bottom: 4px;

        eon-ui-headline {
          color: v(contentColor);
        }
      }

      .#{$prefix}content-aggregator-item__list--body {
        eon-ui-text {
          color: v(contentColor);
        }
      }

      @include for-size(phone) {
        padding: 0px 16px 24px 16px;
        grid-area: 3;
      }
    }

    &.#{$prefix}size-copy {
      padding: 33px 28px 33px 48px;

      @include for-size(desktop) {
        padding: 24px 32px;
      }

      @include for-size(tablet) {
        padding: 24px 24px 24px 32px;
      }

      .#{$prefix}content-aggregator-item__list--headline {
        margin-bottom: 2px;

        eon-ui-headline {
          color: v(contentColor);
        }
      }

      @include for-size(phone) {
        padding: 0px 16px 24px 16px;
        grid-area: 3;
      }
    }
  }

  &--date {
    font-family: $font-family-base;
    grid-column: col-start / span 1;
    eon-ui-date-event {
      --dateColor: var(--contentColor);
      --borderLeft: 1px solid var(--leftBorderColor);
    }

    &.#{$prefix}hide-time {
      padding: 24px 0 24px 40px;
      @include for-size(phone) {
        padding: 12px 0 16px 16px;
        height: 36px;
        justify-content: center;
      }

      @include for-size(tablet) {
        min-width: 88px;
      }

      @include for-size(desktop-or-larger) {
        min-width: 90px;
      }
    }

    &.#{$prefix}show-time {
      padding: 24px 0 24px 32px;

      @include for-size(desktop) {
        padding: 24px 0 24px 32px;
      }

      @include for-size(tablet) {
        padding: 24px 0 24px 32px;
      }

      @include for-size(phone) {
        padding: 12px 0 16px 16px;
        height: 50px;
        justify-content: center;
      }

      @include for-size(tablet-or-larger) {
        min-width: 160px;
      }
    }

    &.#{$prefix}size-h5 {
      @include for-size(desktop-l-or-larger) {
        padding: 27px 0 27px 32px;
      }

      @include for-size(desktop) {
        padding: 25px 0 25px 32px;
      }
    }

    &.#{$prefix}size-copy {
      @include for-size(desktop-l-or-larger) {
        padding: 33px 0 33px 32px;
      }

      @include for-size(desktop) {
        padding: 24px 0 24px 32px;
      }
    }

    &.#{$prefix}copy {
      padding: 24px 32px;
    }

    &.#{$prefix}list-category {
      padding: 24px 0 24px 32px;

      @include for-size(phone) {
        padding: 20px 0 16px 16px;
      }

      @include for-size(tablet) {
        min-width: 88px;
      }

      @include for-size(desktop-or-larger) {
        min-width: 90px;
      }
    }

    &.#{$prefix}hour-format {
      @include for-size(tablet-or-larger) {
        min-width: 130px;
      }
    }

    @include for-size(phone) {
      display: flex;
      flex-direction: column;
      column-gap: 8px;
      position: absolute;
    }
  }
  &--category {
    color: v(contentColor);
    overflow-wrap: break-word;
    word-break: break-word;
  }

  &--button {
    font-family: $font-family-base;
    padding-right: 24px;
    grid-column: 12 col-start / -1;
    display: flex;
    justify-content: center;
    align-items: center;

    @include for-size(phone) {
      grid-area: 1;
      display: flex;
      flex-direction: row;
      column-gap: 8px;
      justify-content: flex-end;
      align-items: flex-end;

      &.#{$prefix}show-time {
        padding: 13px 13px 15px 0;
      }

      &.#{$prefix}hide-time {
        padding: 8px 8px 8px 0;
      }
    }
  }
}

::slotted(eon-ui-link) {
  --contentColor: var(--linkColor) !important;
  --contentHoverColor: var(--linkHoverColor) !important;
  --contentFocusColor: var(--linkHoverColor) !important;
}

::slotted(eon-ui-linkList) {
  --linklistColor: var(--linkColor);
  --linklistHoverColor: var(--linkHoverColor);
}
